import React from 'react'

import classNames from 'classnames'
import i18n from 'i18n'

import { confirmBase } from 'utils/ui'

import SelectUser from 'popups/component/SelectUser'
import SelectFeatherIcon from 'popups/component/SelectFeatherIcon'
import arrowLeftIcon from '@/assets/images/arrow-left.svg'

import styles from './style.module.scss'

export function selectUser(opts0) {
  const opts = opts0 || {}

  const extObj = {
    compAttrs: {
      userOnly: opts.userOnly,
      defaultEmailList: opts.defaultList,
      excludeEmailList: opts.excludeList,
      excludeGroupIds: opts.excludeGroupIds,
    },
    selectedList: [],
    selectedUserList: [],
    selectedGroupIds: [],
    selectedGroupList: [],
  }

  const isMobile = () => window.innerWidth <= 768

  // 초기 icon
  const getCloseIcon = () => (isMobile() ? <img src={arrowLeftIcon} alt="close" /> : true)

  extObj.compAttrs.onUserSelectChanged = (changedEmailList, changedUserList) => {
    extObj.selectedList = [...changedEmailList]
    extObj.selectedUserList = [...changedUserList]

    extObj.updateModal()

    if (opts.onUserSelectChanged) {
      opts.onUserSelectChanged(extObj.selectedList, extObj.selectedUserList)
    }
  }

  extObj.compAttrs.onGroupSelectChanged = (changedGroupIdList, changedGroupList) => {
    extObj.selectedGroupIds = [...changedGroupIdList]
    extObj.selectedGroupList = [...changedGroupList]

    extObj.updateModal()

    if (opts.onGroupSelectChanged) {
      opts.onGroupSelectChanged(extObj.selectedGroupIds, extObj.selectedGroupList)
    }
  }

  const modalCfg = {
    title: opts.title,
    wrapClassName: classNames(styles.selectUserPopup, 'selectUserPopup'),
    closeIcon: getCloseIcon(),
    content: <SelectUser {...extObj.compAttrs} />,
    okText: opts.okText || i18n.t('common.button.shareOk'),
    cancelText: i18n.t('common.button.cancel'),
    maskTransitionName: classNames(styles.maskTransitionName, 'maskTransitionName'),
    width: 640,
    closable: true,
    maskClosable: true,
    okButtonProps: {
      disabled: extObj.selectedList.length < 1 && extObj.selectedGroupIds.length < 1,
      className: classNames('type1', 'h38'),
      style: { minWidth: '100px' },
    },
    cancelButtonProps: {
      className: classNames('h38'),
      style: { minWidth: '100px' },
    },
    onOk: (closeFunc) => {
      if (opts.onOk) {
        opts.onOk(
          {
            selectedEmailList: extObj.selectedList,
            selectedUserList: extObj.selectedUserList,
            selectedGroupIds: extObj.selectedGroupIds,
            selectedGroupList: extObj.selectedGroupList,
          },
          closeFunc,
        )
      } else {
        closeFunc()
      }
    },
    onCancel: () => {
      if (opts.onCancel) {
        opts.onCancel('cancel')
      }
    },
    afterClose: () => {
      window.removeEventListener('resize', extObj.handleResize)
      if (opts.afterClose) opts.afterClose()
    },
  }

  extObj.modalObj = confirmBase(modalCfg)

  extObj.updateModal = () => {
    extObj.modalObj.update({
      okButtonProps: {
        disabled: extObj.selectedList.length < 1 && extObj.selectedGroupIds.length < 1,
        className: classNames('type1', 'h38'),
        style: { minWidth: '100px' },
      },
    })
  }

  // 💡 모바일 여부에 따라 icon 동적 변경
  extObj.handleResize = () => {
    extObj.modalObj.update({
      closeIcon: getCloseIcon(),
    })
  }

  window.addEventListener('resize', extObj.handleResize)

  return extObj
}

export function selectIcon(opts0) {
  const opts = opts0 || {}

  const extObj = {
    compAttrs: {
      defaultIcon: opts.defaultIcon,
    },
    selectedIcon: null,
  }

  extObj.compAttrs.onIconSelected = (iconName) => {
    extObj.selectedIcon = iconName

    if (opts.onIconSelected != null) {
      opts.onIconSelected(extObj.selectedIcon)
    }

    // 선택되면 창을 닫음.
    extObj.modalObj.destroy()
  }

  extObj.render = () => {
    return <SelectFeatherIcon {...extObj.compAttrs} />
  }

  const modalCfg = {
    title: opts.title,
    wrapClassName: classNames(styles.selectIconPopup),
    icon: null,
    content: extObj.render(),
    maskTransitionName: 'maskTransitionName',
    width: 392,
    style: { height: '520px' },
    // closable: true,
    maskClosable: true,
    footer: null,
    afterClose: () => {
      if (opts.afterClose != null) {
        opts.afterClose()
      }
    },
  }

  extObj.modalObj = confirmBase(modalCfg)

  extObj.updateModal = () => {
    extObj.modalObj.update({
      content: extObj.render(),
    })
  }

  return extObj
}

const popupProps = {
  selectUser,
  selectIcon,
}

export default popupProps
